type EnumLiteralsOf<T extends unknown> = T[keyof T];
export const CodItemStatus = Object.freeze({
  PENDING: 1 as const,
  CHECKING: 2 as const,
  CHECKED: 3 as const,
  REJECT: 4 as const,
});

export type CodItemStatus = EnumLiteralsOf<typeof CodItemStatus>;
